var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fortune-teller-ball,future"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1671 6.09709C13.1231 5.96764 12.8769 5.96764 12.833 6.09709C12.7066 6.46962 12.5051 6.93052 12.2178 7.21783C11.9305 7.50513 11.4696 7.70656 11.0971 7.83298C10.9676 7.87691 10.9676 8.12315 11.0971 8.16708C11.4696 8.29351 11.9305 8.49493 12.2178 8.78223C12.5051 9.06954 12.7066 9.53044 12.833 9.90297C12.8769 10.0324 13.1231 10.0324 13.1671 9.90297C13.2935 9.53044 13.4949 9.06954 13.7822 8.78223C14.0695 8.49493 14.5304 8.29351 14.903 8.16708C15.0324 8.12315 15.0324 7.87691 14.903 7.83298C14.5304 7.70656 14.0695 7.50513 13.7822 7.21783C13.4949 6.93052 13.2935 6.46962 13.1671 6.09709Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6879 9.35928C15.6385 9.21365 15.3615 9.21365 15.3121 9.35928C15.1698 9.77837 14.9432 10.2969 14.62 10.6201C14.2968 10.9433 13.7783 11.1699 13.3592 11.3121C13.2136 11.3616 13.2136 11.6386 13.3592 11.688C13.7783 11.8302 14.2968 12.0568 14.62 12.38C14.9432 12.7032 15.1698 13.2218 15.3121 13.6408C15.3615 13.7865 15.6385 13.7865 15.6879 13.6408C15.8302 13.2218 16.0568 12.7032 16.38 12.38C16.7032 12.0568 17.2217 11.8302 17.6408 11.688C17.7864 11.6386 17.7864 11.3616 17.6408 11.3121C17.2217 11.1699 16.7032 10.9433 16.38 10.6201C16.0568 10.2969 15.8302 9.77837 15.6879 9.35928Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M8.00621 18C5.61158 16.6115 4 14.0126 4 11.0357C4 6.59771 7.58172 3 12 3C16.4183 3 20 6.59771 20 11.0357C20 14.0126 18.3884 16.6115 15.9938 18M6.72361 18.5528L6.22361 19.5528C5.89116 20.2177 6.37465 21 7.11803 21H16.882C17.6253 21 18.1088 20.2177 17.7764 19.5528L17.2764 18.5528C17.107 18.214 16.7607 18 16.382 18H7.61803C7.23926 18 6.893 18.214 6.72361 18.5528Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.df94104e8978c2570bf43d8e78a51204.svg";
export { ForwardRef as ReactComponent };